import { j as e } from "./atoms-v218.js";
import { forwardRef as V } from "react";
import { UpgradeRoom as P, ContentPicture as l, Content as j, MobilePictureWrapper as g, ContentHeader as h, ContentHeaderBackground as p, ContentSubtitle as f, ContentTitle as u, ContentArea as C, SpecList as R, ContentButton as L, V2Pictures as U } from "./atoms-v21035.js";
import { Column as _ } from "./atoms-v212.js";
import { useBreakpoints as T } from "./atoms-v251.js";
const k = {
  small: "16/9",
  // eslint-disable-next-line sort-keys
  medium: "16/9",
  // eslint-disable-next-line sort-keys
  large: "1/1",
  xLarge: "3/2",
  // eslint-disable-next-line sort-keys
  max: "3/2"
}, A = ({
  buttonText: a,
  content: t,
  onClickButton: n,
  pictures: r,
  specs: s,
  subtitle: i,
  title: m
}) => {
  const { current: c } = T(), o = k[c];
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      _,
      {
        large: 4,
        max: 7,
        offset: { xLarge: 1, max: 1 },
        span: 0,
        xLarge: 8,
        children: /* @__PURE__ */ e.jsx(l, { aspectRatio: o, ...r[0] })
      }
    ),
    /* @__PURE__ */ e.jsxs(
      j,
      {
        large: 4,
        max: 5,
        medium: 8,
        offset: { xLarge: 1, max: 1 },
        small: 4,
        span: 8,
        xLarge: 5,
        children: [
          /* @__PURE__ */ e.jsx(g, { children: /* @__PURE__ */ e.jsx(l, { aspectRatio: o, ...r[0] }) }),
          /* @__PURE__ */ e.jsxs(h, { children: [
            /* @__PURE__ */ e.jsx(p, {}),
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx(f, { children: i }),
              /* @__PURE__ */ e.jsx(u, { children: m })
            ] }),
            /* @__PURE__ */ e.jsxs(C, { children: [
              t,
              s && /* @__PURE__ */ e.jsxs(R, { children: [
                s,
                " "
              ] })
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(L, { onClick: n, children: a })
        ]
      }
    )
  ] });
}, E = {
  small: "16/9",
  // eslint-disable-next-line sort-keys
  medium: "16/9",
  // eslint-disable-next-line sort-keys
  large: "3/4",
  xLarge: "3/4",
  // eslint-disable-next-line sort-keys
  max: "3/4"
}, S = ({
  buttonText: a,
  content: t,
  onClickButton: n,
  pictures: r,
  specs: s,
  subtitle: i,
  title: m
}) => {
  const { current: c } = T(), o = E[c], x = r.slice(0, 2);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      j,
      {
        large: 3,
        max: 5,
        medium: 8,
        offset: { xLarge: 1, max: 1 },
        small: 4,
        span: 8,
        xLarge: 5,
        children: [
          /* @__PURE__ */ e.jsx(g, { children: /* @__PURE__ */ e.jsx(l, { aspectRatio: o, ...r[0] }) }),
          /* @__PURE__ */ e.jsxs(h, { children: [
            /* @__PURE__ */ e.jsx(p, {}),
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx(f, { children: i }),
              /* @__PURE__ */ e.jsx(u, { children: m })
            ] }),
            /* @__PURE__ */ e.jsxs(C, { children: [
              t,
              s && /* @__PURE__ */ e.jsxs(R, { children: [
                s,
                " "
              ] })
            ] })
          ] }),
          /* @__PURE__ */ e.jsx(L, { onClick: n, children: a })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(
      U,
      {
        large: 5,
        max: 8,
        offset: { xLarge: 1, max: 1 },
        span: 0,
        xLarge: 8,
        children: (x == null ? void 0 : x.length) > 0 ? x.map((d) => /* @__PURE__ */ e.jsx(l, { aspectRatio: o, ...d }, d.defaultSource)) : null
      }
    )
  ] });
}, v = V(
  ({ className: a, id: t, variant: n = "v1", ...r }, s) => /* @__PURE__ */ e.jsxs(P, { className: a, id: t, ref: s, tagName: "article", children: [
    n === "v1" && /* @__PURE__ */ e.jsx(A, { ...r }),
    n === "v2" && /* @__PURE__ */ e.jsx(S, { ...r })
  ] })
);
v.displayName = "Blocks.UpgradeRoom";
export {
  v as UpgradeRoom
};
